import $ from 'jquery';

// Adding jQuery to the global scope
global.$ = global.jQuery = $;
